import type { WorkerSchema } from '../types'

/** Soft-dismissed + TTL-expired items (DB inactive queue), not hot-queue Redis. */
export const BillLinReceivableInactiveSchema: WorkerSchema = {
  workerId: 'bill-lin-receivable-inactive',
  workerLabel: 'รายการเก่า',
  tabIcon: 'package',
  recordPrefix: 'AG',
  apiEndpoint: '',
  defaultSort: { col: 'queue_left_at', dir: 'desc' },
  searchFields: ['title', 'amount', 'order_id', 'entity_id'],

  columns: [
    {
      id: 'kind_label',
      header: 'ประเภท',
      type: 'text',
      editable: false,
      sortable: true,
      visibility: 'always',
      width: 96,
    },
    {
      id: 'title',
      header: 'รายการ',
      type: 'text',
      editable: false,
      sortable: true,
      visibility: 'always',
    },
    {
      id: 'amount_remaining',
      header: 'รอจัดสรร',
      type: 'amount',
      editable: false,
      sortable: true,
      visibility: 'always',
      align: 'right',
    },
    {
      id: 'queue_left_at',
      header: 'ออกจากคิว',
      type: 'datetime',
      editable: false,
      sortable: true,
      visibility: 'always',
      width: 150,
    },
    {
      id: '__status__',
      header: 'สถานะ',
      type: 'status',
      editable: false,
      visibility: 'always',
    },
  ],

  drawerSections: [
    {
      label: 'DETAILS',
      fields: [
        'kind_label',
        'title',
        'amount',
        'amount_remaining',
        'queue_left_at',
        'queue_left_reason',
        'order_id',
        'entity_id',
      ],
    },
  ],

  filterOptions: {
    status: ['รายการที่ลบ', 'หมดอายุ'],
    categories: ['สลิป', 'ประกาศ', 'ที่อยู่'],
    datePresets: [
      'วันนี้',
      '7 วันที่ผ่านมา',
      'เดือนนี้',
      'เดือนที่แล้ว',
      'กำหนดเอง',
    ],
  },

  emptyState: {
    icon: '📦',
    title: 'ยังไม่มีรายการเก่า',
    body: 'รายการที่ลบออกจากคิวหรือหมดอายุจะโผล่ที่นี่ — เงินจริงยังอยู่ในระบบ',
  },
}
